import { MesterplanApi, type ApiResult } from '@mesterplan/api-client';

export const adminApi = new MesterplanApi({
  baseUrl: import.meta.env.VITE_MESTERPLAN_API_URL ?? '',
  credentials: 'include',
}).platformAdmin;

export class AdminRequestError extends Error {
  constructor(
    public readonly status: number,
    message: string,
    /** ProblemDetails `code` and field errors, kept so a form can map them to its own Danish text. */
    public readonly code?: string,
    public readonly fieldErrors?: Record<string, string[]>,
  ) { super(message); }
}

export async function adminData<T>(request: Promise<ApiResult<T>>): Promise<T> {
  const result = await request;
  if (!result.ok) {
    const fields = Object.values(result.error.errors ?? {}).flat().join(' ');
    throw new AdminRequestError(result.status, fields || result.error.detail || result.error.title || 'Handlingen kunne ikke gennemføres.', result.error.code, result.error.errors);
  }
  return result.data;
}
